import { render, staticRenderFns } from "./SelectCity.vue?vue&type=template&id=bff5b1a8&"
import script from "./SelectCity.vue?vue&type=script&lang=js&"
export * from "./SelectCity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports